import axios from 'axios';

const HOST = '/api';
const $axios = axios.create({
	baseURL: HOST,
	withCredentials: true,
});

$axios.interceptors.response.use(
	function (response) {
		return response;
	},
	function (error) {
		if (!!error.response && error.response.status === 401) {
			// Не редиректим на /login если пользователь на странице регистрации или документов
			const currentHash = window.location.hash;
			const isRegisterPage = currentHash.includes('/register') || currentHash.includes('/forgot-password') || currentHash.includes('/recovery-password');
			const isDocsPage = currentHash.startsWith('#/docs/');
			const isLoginPage = currentHash.startsWith('#/login');

			if (!isRegisterPage && !isDocsPage) {
				// Lazy import чтобы избежать циклической зависимости store -> api -> store
				import('src/store/store').then(({ default: store }) => {
					import('src/store/auth').then(({ setAuthUser }) => {
						store.dispatch(setAuthUser(null));
					});
				});

				// Запоминаем страницу, чтобы вернуть на неё после входа
				const returnPath = currentHash.slice(1) || '/';
				window.location.href = isLoginPage ? '#/login' : `#/login?returnUrl=${encodeURIComponent(returnPath)}`;
			}
		}
		return Promise.reject(error);
	}
);

export default $axios;
